import { supabase } from '../supabaseClient';
import { debug } from '../helpers/debug';

export async function apiMoveItemsToProject(srcProjectId, destProjectId, items = [], destParentId = null, onConflict = 'error') {
  try {
    if (!Array.isArray(items) || items.length === 0) return { status: 'no_items' };
    const payload = items.map(i => ({ type: i.type, id: Number(i.id) }));
    const { data, error } = await supabase.rpc('move_items_to_project', {
      p_src_project_id: srcProjectId,
      p_dest_project_id: destProjectId,
      p_items: payload,
      p_dest_parent_id: destParentId,
      p_on_conflict: onConflict
    });
    if (error) throw error;
    return data || { status: 'ok' };
  } catch (err) {
    debug('apiMoveItemsToProject error', { type: 'error' }, err);
    throw err;
  }
}
